import React from 'react';
import PropTypes from 'prop-types';

import Icon from '../Icon';
import Close from '../../svg/icons/close.svg';
import X from '../../svg/icons/x.svg';
import './IconClose.scss';

const IconClose = (props) => {
  const {
    fill, height, width, background,
  } = props;
  const Svg = background
    ? Close
    : X;

  return (
    <Icon
      component={Svg}
      fill={fill}
      height={height}
      name="close"
      width={width}
      data-testid="icon"
    />
  );
};

IconClose.propTypes = {
  fill: PropTypes.string,
  height: PropTypes.string,
  width: PropTypes.string,
  background: PropTypes.bool,
};

IconClose.defaultProps = {
  fill: '#cacaca',
  height: '1em',
  width: '1em',
  background: true,
};

export default IconClose;
